import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roles-roles',
  templateUrl: './roles-roles.component.html',
  styleUrls: ['./roles-roles.component.scss']
})
export class RolesRolesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
